export default __webpack_public_path__ + "static/media/laptop_ja.5f5de5cb.png";